export const getStoredDetectedLocation = () => {
    try {
        const savedLocation = localStorage.getItem('detectedLocation');
        return savedLocation ? JSON.parse(savedLocation) : null;
    } catch (error) {
        console.warn('[Location] Failed to parse detectedLocation from localStorage', error);
        return null;
    }
};

export const saveDetectedLocation = (location) => {
    if (!location) return;
    localStorage.setItem('detectedLocation', JSON.stringify(location));
};

export const getDetectedLocationLabel = (location = getStoredDetectedLocation()) => {
    if (!location) return '';
    return location.label || [location.city, location.state, location.country].filter(Boolean).join(', ') || '';
};

export const buildLocationLogHeaders = () => {
    const detectedLocation = getStoredDetectedLocation();
    const locationLabel = getDetectedLocationLabel(detectedLocation);

    if (!detectedLocation && !locationLabel) {
        return {};
    }

    return {
        location: encodeURIComponent(JSON.stringify({
            label: locationLabel,
            latitude: detectedLocation?.latitude,
            longitude: detectedLocation?.longitude,
            countryCode: detectedLocation?.countryCode,
            city: detectedLocation?.city,
            state: detectedLocation?.state,
            country: detectedLocation?.country,
            isEurope: detectedLocation?.isEurope,
        })),
    };
};
